import Acordion from "./Acordion";
import styles from "./cart.module.css";
import x1 from "assets/images/axnew1.png";
import panir from "assets/images/panir.jpg";
import gusht from "assets/images/gusht.png";
import pic from "assets/images/cover2.png";
import "./scss/step-bar.scss";

import { BiTrash } from "react-icons/bi";
import { BsPlus } from "react-icons/bs";
import { HiMinusSm, HiTrash } from "react-icons/hi";
import { FaCheck } from "react-icons/fa";
import "./Orders.scss";
import { useState, useEffect, useContext } from "react";
import { addCommas } from "@persian-tools/persian-tools";
import { connection } from "../../../utils/apiConnection.ts";
import Loader from "utils/Loader";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

function ShoppingCart({
  typeee,
  data,
  updateShoppingList,
  index,
  length,
  setIsLoading,
}) {
  const [item, setItems] = useState(0);

  const discountSection = (totalPrice, salePrice, count) => {
    // console.log("sale price in section", salePrice == "0" ? "a" : "b");
    let element;
    salePrice == "0"
      ? (element = (
          <div className="">
            <div className={styles.bdiSt}>
              {" "}
              قیمت
              {addCommas(totalPrice * count)} تومان
            </div>
          </div>
        ))
      : (element = (
          <div className="d-flex align-items-center  justify-content-center">
            <div className=" align-items-center  mx-2">
              <div className="d-flex justify-content-center">
                {/* <p className={styles.offSt2}>
                {Math.floor((salePrice / totalPrice) * 100)} %
              </p> */}
                <p className={styles.priceSt}>
                  {" "}
                  قیمت
                  {addCommas(totalPrice * count)} تومان
                </p>
              </div>

              <p className={`text-danger ${styles.finalPrice}`}>
                قیمت نهایی
                {addCommas((totalPrice - salePrice) * count)}
                <bdi className={styles.bdiSt}>تومان</bdi>
              </p>
            </div>
          </div>
        ));
    return element;
  };
  const addCartItem = (type, id, count, price) => {
    let temp = { count: count, price: price };
    setIsLoading(true);
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id };
    }
    connection("api/addcartitem", temp).then((data) => {
      if (data.status == 1) {
        updateShoppingList();
      } else {
        toast.error("در حال حاضر امکان افزودن کالا وجود ندارد.");
        setIsLoading(false);
      }
    });
  };
  const reduceCartItem = (type, id) => {
    let temp = {};
    setIsLoading(true);
    if (type == "basket") {
      temp = { ...temp, basketId: id };
    } else if (type == "product") {
      temp = { ...temp, productForOrderId: id };
    }
    connection("api/reducecartitems", temp).then((data) => {
      if (data.status == 1) {
        updateShoppingList();
      } else {
        toast.error("در حال حاضر امکان کم کردن کالا وجود ندارد.");
        setIsLoading(false);
      }
    });
  };
  const countProduct = async (
    min,
    totalCount,
    completeCount,
    frozenCount,
    count,
    operate
  ) => {
    let max = +totalCount - +completeCount - +frozenCount;
    let valid = false;
    if (operate == "plus") {
      if (count == max) {
        toast.error(`امکان سفارش این کالا بیش از ${max} عدد وجود ندارد.`);
      } else {
        valid = true;
      }
    } else if (operate == "minus") {
      if (count == min) {
        valid = await Swal.fire({
          icon: "warning",
          title: `حداقل تعداد سفارش این کالا ${min}  می باشد. آیا از حذف این محصول مطمئن هستید؟ `,
          showCancelButton: true,
          cancelButtonText: "انصراف",
          confirmButtonText: "حذف",
          cancelButtonColor: "#EF394E",
          confirmButtonColor: "#439B58",
        }).then(({ isConfirmed }) => isConfirmed);
      } else {
        valid = true;
      }
    }
    // console.log("HERE");
    return valid;
  };
  // console.log("shopping data", data.product_title);
  return (
    <>
      {" "}
      <div className="py-2 px-3">
        <div className="d-flex flex-wrap align-items-center justify-content-between ">
          <div className="col-12 col-sm-8 col-md-6 col-xl-6">
            <div
              className={`d-flex  justify-content-between  ${styles.nameContainer}`}
            >
              <div className="d-flex align-items-center">
                <img
                  src={`${
                    data.path != null
                      ? `http://sabadi.tatdemo.ir/${data.path}`
                      : `http://sabadi.tatdemo.ir/${data.product_info.path}`
                  }`}
                  className={styles.imgSt}
                />
                <div>
                  <p
                    className={`${styles.titleHead1} ${styles.oneLine}`}
                    // style={{ width: "20px" }}
                  >
                    {data.product_title}
                  </p>
                  {/* {type != 0 && (
                  <div className={`${type == 0 && "d-none"}`}>
                    <div
                      className={`d-flex align-items-baseline ms-2 ${styles.storeName}`}
                      // style={{ width: "200px" }}
                    >
                      <div>
                        <img
                          className="shadow"
                          src={
                            data.supplier_info.path != null
                              ? `http://sabadi.tatdemo.ir/${data.supplier_info.path}`
                              : logo
                          }
                          style={{
                            width: "30px",
                            height: 30,
                            borderRadius: "50%",
                          }}
                        />
                      </div>
                      <p className="ms-2" style={{ fontSize: "14px" }}>
                        {data.supplier_info.title}
                      </p>
                    </div>
                  </div>
                )} */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-4 col-md-2 col-xl-2">
            <div
              className={`${typeee == 0 && "d-none"} ${
                styles.divbtt
              } d-flex align-items-center justify-content-evenly border rounded-pill mx-auto`}
            >
              <div>
                <button
                  // className={`bg-danger ${styles.btn} ${styles.inc}`}
                  className={`btn text-center ${styles.noneShadow}`}
                  style={{ width: "20" }}
                  // onClick={onInc}
                >
                  <BsPlus
                    className={styles.trashbtn}
                    onClick={async () => {
                      let validation = await countProduct(
                        0,
                        data.apo_info.total_inventory_count,
                        data.apo_info.complate_inventory_count,
                        data.apo_info.frozen_inventory_count,
                        data.current_count,
                        "plus"
                      );
                      if (validation) {
                        addCartItem(
                          "product",
                          data.avb_product_for_order_id,
                          1,
                          data.total_price
                        );
                      }
                    }}
                  />
                </button>
              </div>

              <span
                style={{ width: "20" }}
                className={`text-center ${styles.quant}`}
              >
                {data.current_count}
              </span>
              <div>
                <button
                  // className={`${styles.btn} ${styles.remove}`}
                  className={`btn ${styles.noneShadow}`}
                  style={{ width: "20" }}
                  // onClick={onDecrease}
                >
                  {data.current_count ==
                  (data.apo_info.min_order_count != "0"
                    ? data.apo_info.min_order_count
                    : "1") ? (
                    <HiTrash
                      className={styles.trashbtn}
                      onClick={async () => {
                        let validation = await countProduct(
                          data.apo_info.min_order_count,
                          0,
                          0,
                          0,
                          data.current_count,
                          "minus"
                        );
                        if (validation) {
                          reduceCartItem(
                            "product",
                            data.avb_product_for_order_id
                          );
                        }
                      }}
                    />
                  ) : (
                    <HiMinusSm
                      className={styles.trashbtn}
                      onClick={async () => {
                        let validation = await countProduct(
                          data.apo_info.min_order_count,
                          0,
                          0,
                          0,
                          data.current_count,
                          "minus"
                        );
                        if (validation) {
                          reduceCartItem(
                            "product",
                            data.avb_product_for_order_id
                          );
                        }
                      }}
                    />
                  )}
                </button>
              </div>

              {/* <div style={{ color: "red", fontSize: "12px" }} className="mt-1">
              {data.apo_info.min_order_count != "0" &&
                `حداقل تعداد سفارش : ${data.apo_info.min_order_count}`}
            </div> */}
            </div>
          </div>
          <div
            className={`${
              typeee != 0 && "d-none"
            } col-12 col-sm-4 col-md-2 col-xl-2 text-center`}
          >
            {" "}
            {data.current_count}عدد
          </div>
          <div
            className={`${
              typeee != 0 && "d-none"
            }  col-12 col-sm-6 col-xl-4 text-center`}
          >
            {discountSection(
              data.total_price,
              data.discount,
              data.current_count
            )}
          </div>
          <div
            className={`${
              typeee == "0" && "d-none"
            } col-12 col-md-4 col-xl-4 text-center`}
          >
            {discountSection(
              data.total_price,
              data.discount,
              data.current_count
            )}
          </div>
        </div>
      </div>
      <div
        className=" mx-5 pb-3"
        style={
          index == length - 1
            ? { borderBottom: "none" }
            : { borderBottom: "0.5px solid #ccc" }
        }
      ></div>
    </>
  );
}

export default ShoppingCart;
